import { render, staticRenderFns } from "./rawtail.vue?vue&type=template&id=136789a1&"
import script from "./rawtail.vue?vue&type=script&lang=js&"
export * from "./rawtail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports